export default __webpack_public_path__ + "4f195384f0e83e830c7c5fdf6aad2ccc.svg";